<template>
    <v-dialog v-model="dialogModel" max-width="400">

        <!-- TOOLBAR -->
        <toolbar-page title="Please select nominations">
            <template slot="buttons">

                <v-tooltip color="primary" top>
                    <template v-slot:activator="{ on }">
                        <v-btn @click="closeDialog()" class="mr-1" icon small color="white" v-on="on">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </template>
                    <span>Cancel</span>
                </v-tooltip>
            </template>
        </toolbar-page>

        <!-- CARD BODY -->
        <v-card class="pt-4">
            <v-card-text class="pb-0">

                <v-alert type="info" class="body-2 mb-0">Please select the nominations your would like to offer
                </v-alert>

                <v-item-group multiple v-model="selected">
                    <v-container>

                        <!-- NOMINATIONS -->
                        <v-row dense>
                            <v-col cols="6" v-for="nomination in nominationsAvailable" :key="nomination" class="pt-2 pr-2">
                                <v-item v-slot:default="{ active, toggle }">
                                    <v-card
                                        :color="active ? 'primary' : 'grey darken-2'"
                                        class="d-flex align-center"
                                        dark
                                        height="38"
                                        @click="toggle"
                                    >
                                        <div class="font-weight-medium ml-4 mr-4">
                                            {{ nomination }} {{ item.currencyCode }}
                                        </div>
                                    </v-card>
                                </v-item>
                            </v-col>
                        </v-row>

                        <!-- BUTTONS -->
                        <v-row>
                            <v-card-text>
                                <v-container fluid class="pa-0">
                                    <v-row no-gutters>
                                        <v-col cols="6" class="text-left">
                                            <v-btn :disabled="selected.length === 0"
                                                   @click="doneClicked"
                                                   :loading="saving"
                                                   color="primary">Select
                                            </v-btn>
                                        </v-col>
                                        <v-col cols="6" class="text-right">
                                            <v-btn @click="cancelClicked" text>
                                                Cancel
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                        </v-row>
                    </v-container>
                </v-item-group>

                <json v-if="false" :data="item"></json>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

import Json from 'vue-json-pretty';
import StatBoxNumerical from "../../../../components/UI/StatBoxNumerical";
import StatBoxText from "../../../../components/UI/StatBoxText";
import ToolbarPage from "../../../../components/UI/ToolbarPage";
import {mapActions, mapState} from 'vuex';

const vuexModule = 'Rewards';

export default {

    components: {
        Json,
        StatBoxNumerical,
        StatBoxText,
        ToolbarPage
    },

    props: {
        value: {
            type: Boolean,
            required: true,
        },
        brand: {
            type: Object,
            required: true
        }
    },

    watch: {
        value(dialogOpen) {
            if (dialogOpen) {
                this.populateSelected();
            }
        }
    },

    data() {
        return {
            valueModel: this.minValue,
            selected: [],
            saving: false,
            nominationsAvailable: [1, 5, 10, 20, 50, 100, 200, 500, 1000]
        }
    },

    computed: {

        ...mapState(vuexModule, [
            'tangoCardRewards',
        ]),

        item() {
            return this.brand.items[0];
        },

        dialogModel: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        },
    },

    methods: {

        ...mapActions(vuexModule, [
            'setTangoCardNominations'
        ]),

        closeDialog() {
            this.$emit('input', false);
        },

        populateSelected() {
            let rewards = this.tangoCardRewards.filter(reward => this.item.utid === reward.third_party_identifier);

            this.selected = rewards.map(reward => this.nominationsAvailable.findIndex(nomination => nomination === reward.cost));
        },

        doneClicked() {

            let cards = [];

            this.selected.forEach((index) => {

                cards.push({
                    value: this.nominationsAvailable[index],
                    currency_code: this.item.currencyCode,
                    utid: this.item.utid
                });
            })

            this.saving = true;

            this.setTangoCardNominations({
                brand_key: this.brand.brandKey,
                cards: cards,
            })
                .then(response => {
                    Bus.$emit('flash-message', {message:"Cards added to your rewards!"})
                })
                .catch(error => {
                    Bus.$emit('flash-message', {type: 'error', message:"OOPS We failed to add the cards! Try again later!"})
                })
                .finally(() => {
                    this.saving = false;
                })

            this.closeDialog()
        },

        cancelClicked() {
            this.selected = [];
            this.closeDialog();
        },
    }
}
</script>
